module.exports = __webpack_public_path__ + "static/media/bg_dashboard_banner.0e114236.png";